import React from "react";
import ProductRelateItem from './ProductRelateItem';

class ProductRelate extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      currentProducts:this.props.products.category
    }
  }
  addToCart = (product)=>{
    this.props.addToCart(product,false, 1);
  }
  handleChangeDeal = (deal, e) =>{
    const $ = window.jQuery;
    e.preventDefault();
    $('.load-deal').removeClass('active');
    $(e.target).addClass('active')
    $('body').append('<div class="loading-img"></div>');
    setTimeout(() => {
      this.setState({
        currentProducts:deal
      })
    }, 100);
  }
  componentDidUpdate(){
    const $ = window.jQuery;
    $('div.loading-img').remove();
  }
  
  render() {
    let {products} = this.props;
    let {currentProducts} = this.state;
    let productsItemView = null;
    if(currentProducts.length)
    {
      console.log(currentProducts);
      productsItemView = currentProducts.map((product, idx)=><ProductRelateItem addToCart={this.addToCart} key={idx} product={product} />);  
    }

    return (
      <div className="my-3 row deal-hot pb-2 pb-md-3">
        <div className="w-100 deal-hot__title">
          <h4 className="p-2 m-0 text-uppercase">Sản phẩm liên quan</h4>
          <div className="tab-menu">
            <a href="/" onClick={(e)=>this.handleChangeDeal(products.category, e)} data-type="category" className="active load-deal btn my-2 ml-2 ml-md-3 text-dark">Pibook giới thiệu</a> 
            <a href="/" onClick={(e)=>this.handleChangeDeal(products.author, e)} data-type="author" className="load-deal btn my-2 ml-2 ml-md-3 text-dark">Cùng tác giả</a> 
            <hr className="m-0" />
          </div>
        </div>
        
        <div className="p-2 w-100">
            {productsItemView ? 
            <div className="relate__card__swiper-container swiper-slide-container">
              <div className="swiper-wrapper">
               {productsItemView}
              </div>
              {/* Add Arrows */}
              <div className="swiper-button-next"></div>
              <div className="swiper-button-prev"></div>
            </div>
            :null}
        </div>
      </div>
    );
  }
}
export default ProductRelate;
